import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoutes from './App';
import { Provider } from 'react-redux'
import store from './redux-store/store'
import { Analytics } from "@vercel/analytics/react"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AppRoutes />
    <Analytics/>
  </Provider>
);
